module.exports = "/_next/static/images/db8f3d6e6667206d6d627c7b4f874d3e-card-and-phone-3d-lg@1x.jpg.webp";